export type { PanelProps } from './Panel'
export { Panel } from './Panel'
